module.exports = __webpack_public_path__ + "static/media/partner-store-list-ic5.52fa39fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/partner-store-list-ic5.png
// module id = 546
// module chunks = 0